<template>
  <zen-one 
  :showuserinfo="false" 
  title="Pentadbiran"
  :crumbs="crumbs"
  >
  <z-page
  title="Tadbir Menu"
  >

  <w-card bg-color="z-pale-blue" class="mt4" v-if="menu">
    <w-flex class="mt3">
      <div class="xs4">
          <h5 class="fw-semibold m0">
              Label :
          </h5>
          <div class="fw-normal my1 fs-1"> {{ menu.label }} </div>
      </div>
      <div class="xs4">
          <h5 class="fw-semibold m0">
              Ikon :
          </h5>
          <div class="fw-normal my1 fs-1"> {{ menu.icon }} </div>
      </div>
      <div class="xs4">
          <h5 class="fw-semibold m0">
              Route :
          </h5>
          <div class="fw-normal my1 fs-1"> {{ menu.route }} </div>
      </div>
    </w-flex>

    <w-flex class="mt3 mb4">
        <div class="xs4">
          <h5 class="fw-semibold m0">
              Tarikh Cipta :
          </h5>
          <div class="fw-normal my1 fs-1"> {{ $zutil.dateformat(menu.created_at) }} </div>
      </div>
        <div class="xs4">
            <h5 class="fw-semibold m0">
                Tarikh Ubah Akhir :
            </h5>
            <div class="fw-normal my1 fs-1"> {{ $zutil.dateformat(menu.updated_at) }} </div>
        </div>
    </w-flex>

  </w-card>
  
  <MenuList
    :menu="menu"
    :items="items"
  />

  </z-page>
  </zen-one>
</template>

<script>

import MenuList from './Subs/Menu.vue'

export default {
  components: {
    MenuList,
  },
  props: {
    menu: [Array, Object],
    items: [Array, Object],
  },
  data() {
    return {
      crumbs: [
        { label: this.$page.props.app_name, route: '/sitemap' },
        { label: 'Utama', route: '/' },
        { label: 'Pentadbiran', route: '/admin' },
        { label: 'Menu', route: '/admin/menu' }
      ]
    }
  },
}
</script>